const API_VERSION = 'v1';

const BASE_PATH = `/api/${API_VERSION}`;



export const API_ENDPOINTS = {

  // Authentication

  AUTH: {

    REGISTER: `${BASE_PATH}/register`,

    LOGIN: `${BASE_PATH}/login`,

    LOGOUT: `${BASE_PATH}/logout`,

    ME: `${BASE_PATH}/me`,

    CHANGE_PASSWORD: `${BASE_PATH}/change-password`,

  },



  // Public APIs

  PUBLIC: {

    PROJECTS: `${BASE_PATH}/public/projects`,

    PROJECT_DETAIL: (id: number) => `${BASE_PATH}/public/projects/${id}`,

    COMPANY: `${BASE_PATH}/public/company`,

    CONTACT: `${BASE_PATH}/public/contact`,

    SPECIALIZATIONS: `${BASE_PATH}/specializations`,

    SITE_SETTINGS: `${BASE_PATH}/public/site-settings`,

    CONTENT: {

      HOMEPAGE: `${BASE_PATH}/public/content/homepage`,

      ABOUT: `${BASE_PATH}/public/content/about`,

      HOW_IT_WORKS: `${BASE_PATH}/public/content/how-it-works`,

      FAQS: `${BASE_PATH}/public/content/faqs`,

      CONTACT: `${BASE_PATH}/public/content/contact`,

      NAVIGATION: `${BASE_PATH}/public/content/navigation`,

      FOOTER: `${BASE_PATH}/public/content/footer`,

      ALL: `${BASE_PATH}/public/content/all`,

    },

  },



  // Client APIs

  CLIENT: {

    PROFILE: `${BASE_PATH}/client/profile`,

    PROFILE_DOCUMENTS: `${BASE_PATH}/client/profile/documents`,

    TENDERS: `${BASE_PATH}/client/tenders`,

    TENDER_DETAIL: (id: number) => `${BASE_PATH}/client/tenders/${id}`,

    TENDER_DOCUMENT_DOWNLOAD: (tenderId: number, documentId: number) => `${BASE_PATH}/client/tenders/${tenderId}/documents/${documentId}/download`,

    OFFERS: `${BASE_PATH}/client/offers`,

    OFFER_DETAIL: (id: number) => `${BASE_PATH}/client/offers/${id}`,

    PROJECTS: `${BASE_PATH}/client/projects`,

    PROJECT_DETAIL: (id: number) => `${BASE_PATH}/client/projects/${id}`,

    DASHBOARD: `${BASE_PATH}/client/dashboard`,

  },



  // Admin APIs

  ADMIN: {

    TENDERS: `${BASE_PATH}/admin/tenders`,

    TENDER_DETAIL: (id: number) => `${BASE_PATH}/admin/tenders/${id}`,

    TENDER_DOCUMENTS: (id: number) => `${BASE_PATH}/admin/tenders/${id}/documents`,

    TENDER_DOCUMENT_DELETE: (tenderId: number, documentId: number) => `${BASE_PATH}/admin/tenders/${tenderId}/documents/${documentId}`,

    TENDER_DOCUMENT_DOWNLOAD: (tenderId: number, documentId: number) => `${BASE_PATH}/admin/tenders/${tenderId}/documents/${documentId}/download`,

    OFFERS: `${BASE_PATH}/admin/offers`,

    OFFER_DETAIL: (id: number) => `${BASE_PATH}/admin/offers/${id}`,

    CLIENTS: `${BASE_PATH}/admin/clients`,

    CLIENT_DETAIL: (id: number) => `${BASE_PATH}/admin/clients/${id}`,

    CLIENT_PROFILE: (id: number) => `${BASE_PATH}/admin/clients/${id}/profile`,

    SPECIALIZATIONS: `${BASE_PATH}/admin/specializations`,

    SPECIALIZATION_DETAIL: (id: number) => `${BASE_PATH}/admin/specializations/${id}`,

    SETTINGS: `${BASE_PATH}/admin/settings`,

    SETTING_DETAIL: (key: string) => `${BASE_PATH}/admin/settings/${key}`,

    SETTINGS_STORAGE: `${BASE_PATH}/admin/settings/storage`,

    SETTINGS_EMAIL: `${BASE_PATH}/admin/settings/email`,

    SETTINGS_STORAGE_S3: `${BASE_PATH}/admin/settings/storage/s3`,

    SETTINGS_STORAGE_FILE_TYPES: `${BASE_PATH}/admin/settings/storage/file-types`,

    SITE_SETTINGS: `${BASE_PATH}/admin/site-settings`,
    SITE_SETTINGS_LOGO: `${BASE_PATH}/admin/site-settings/logo`,
    SITE_SETTINGS_LOGO_DARK: `${BASE_PATH}/admin/site-settings/logo-dark`,
    SITE_SETTINGS_FAVICON: `${BASE_PATH}/admin/site-settings/favicon`,

    DASHBOARD: `${BASE_PATH}/admin/dashboard`,

    // Admin Users Management (Super Admin Only)
    ADMINS: `${BASE_PATH}/admin/admins`,
    ADMIN_DETAIL: (id: number) => `${BASE_PATH}/admin/admins/${id}`,
    ADMIN_RESET_PASSWORD: (id: number) => `${BASE_PATH}/admin/admins/${id}/reset-password`,

    // Company Projects (Portfolio)
    COMPANY_PROJECTS: `${BASE_PATH}/admin/company-projects`,
    COMPANY_PROJECT_DETAIL: (id: number) => `${BASE_PATH}/admin/company-projects/${id}`,
    COMPANY_PROJECT_UPDATE_WITH_FILES: (id: number) => `${BASE_PATH}/admin/company-projects/${id}/update-with-files`,
    COMPANY_PROJECTS_ORDER: `${BASE_PATH}/admin/company-projects/order`,
    COMPANY_PROJECT_TOGGLE_ACTIVE: (id: number) => `${BASE_PATH}/admin/company-projects/${id}/toggle-active`,

    // Client Projects Management
    CLIENT_PROJECTS: `${BASE_PATH}/admin/projects`,
    CLIENT_PROJECT_DETAIL: (id: number) => `${BASE_PATH}/admin/projects/${id}`,
    CLIENT_PROJECT_UPDATE_WITH_FILES: (id: number) => `${BASE_PATH}/admin/projects/${id}/update-with-files`,
    CLIENT_PROJECT_STATUS: (id: number) => `${BASE_PATH}/admin/projects/${id}/status`,

    CONTENT: {

      HOMEPAGE: `${BASE_PATH}/admin/content/homepage`,

      HOMEPAGE_HERO_BACKGROUND: `${BASE_PATH}/admin/content/homepage/hero-background`,

      HOMEPAGE_FEATURES: `${BASE_PATH}/admin/content/homepage/features`,

      HOMEPAGE_FEATURE: (id: number) => `${BASE_PATH}/admin/content/homepage/features/${id}`,

      HOMEPAGE_STATISTICS: `${BASE_PATH}/admin/content/homepage/statistics`,

      HOMEPAGE_STATISTIC: (id: number) => `${BASE_PATH}/admin/content/homepage/statistics/${id}`,

      ABOUT: `${BASE_PATH}/admin/content/about`,

      ABOUT_VALUES: `${BASE_PATH}/admin/content/about/values`,

      ABOUT_VALUE: (id: number) => `${BASE_PATH}/admin/content/about/values/${id}`,

      HOW_IT_WORKS: `${BASE_PATH}/admin/content/how-it-works`,

      HOW_IT_WORKS_STEPS: `${BASE_PATH}/admin/content/how-it-works/steps`,

      HOW_IT_WORKS_STEP: (id: number) => `${BASE_PATH}/admin/content/how-it-works/steps/${id}`,

      FAQS: `${BASE_PATH}/admin/content/faqs`,

      FAQ: (id: number) => `${BASE_PATH}/admin/content/faqs/${id}`,

      CONTACT: `${BASE_PATH}/admin/content/contact`,

      NAVIGATION: `${BASE_PATH}/admin/content/navigation`,

      NAVIGATION_LINK: (id: number) => `${BASE_PATH}/admin/content/navigation/${id}`,

      FOOTER: `${BASE_PATH}/admin/content/footer`,

    },

  },

} as const;

